<template>
    <v-row>

        <v-col cols="12" class="px-0">
            <v-data-table
                    dark
                    class="background-table"
                    align="center"
                    :headers="headers"
                    :items="items"
                    :items-per-page="1000"
                    disable-sort
                    hide-default-footer>

                <template v-slot:[`item.image_url`]="{ item }">
                    <img width="100px" :src="item.image_url" class="table-thumb">
                </template>

                <template v-slot:[`item.invoice_url`]="{ item }">
                    <img v-if="item.invoice_url" width="100px" :src="item.invoice_url">
                    <div v-else>-</div>
                </template>

                <template v-slot:[`item.customer`]="{ item }">
                    <div v-if="item.customer">
                        {{ 'شناسه: ' + item.customer.id }} <br>
                        {{ item.customer.name }} <br>
                        {{ item.customer.phone_number }}
                    </div>
                </template>

                <template v-slot:[`item.admin`]="{ item }">
                    <div v-if="item.admin">
                        {{ item.admin.id }} | {{ item.admin.name }}
                    </div>
                    <div v-else>-</div>
                </template>

                <template v-slot:[`item.category`]="{ item }">
                    <div v-if="item.category">
                        {{ item.category.id }} | {{ item.category.fa_name }}
                    </div>
                </template>

                <template v-slot:[`item.status_name`]="{ item }">
                    <v-btn rounded x-small :color="getColorBaseOnStatus(item)">
                        {{ item.status_name }}
                    </v-btn>
                </template>

                <template v-slot:[`item.persian_created_at`]="{ item }">
                    <div class="dates">{{ item.persian_created_at }}</div>
                </template>

                <template v-slot:[`item.persian_updated_at`]="{ item }">
                    <div class="dates">{{ item.persian_updated_at }}</div>
                </template>
            </v-data-table>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "TableWithOutPagination",

    props: ["headers", "items"],

    methods: {
        getColorBaseOnStatus(item) {
            switch (item.status) {
                case 0:
                    return 'warning'
                case 1:
                    return 'info'
                case 2:
                    return 'error'
                case 3:
                    return 'success'
            }
        }
    },
}
</script>

<style scoped>
.background-table {
    background-color: #393E46;
}

.table-thumb {
    display: block;
    margin: 8px auto;
    border-radius: 8px;
    background: #fff;
    object-fit: contain;
}

.pointer {
    cursor: pointer;
}
</style>